import type { ReactNode } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import {
    PackageSwitcherWrapper,
    CloseIcon,
    PackageSwitcherHeader,
    PackageSwitcherFooter,
    PackageSwitcherTitleWrapper,
} from "./ContentStateWrapper.styled";

interface IContentStateWrapperProps {
    onClose: () => void;
    onCancelClick: () => void;
    isDataLoaded: boolean;
    onSubmitButtonClick: () => void;
    isLoadingOrError: boolean;
    packageTitle?: string;
    children: ReactNode;
}

export const ContentStateWrapper = ({
    onClose,
    onCancelClick,
    isDataLoaded,
    onSubmitButtonClick,
    isLoadingOrError,
    packageTitle,
    children,
}: IContentStateWrapperProps) => {
    const { translate } = useTranslate();
    return (
        <PackageSwitcherWrapper>
            <PackageSwitcherHeader>
                <PackageSwitcherTitleWrapper>
                    <Text
                        fontVariant="h5_2"
                        color={colorsPalettes.carbon[500]}
                    >
                        {translate("subscription.info.nt.SwitchPackageModal.title.change")}
                    </Text>
                    {packageTitle ? (
                        <Text
                            fontVariant="chip1"
                            color={colorsPalettes.carbon[400]}
                        >
                            {translate("subscription.info.nt.SwitchPackageModal.title.to", {
                                packageTitle,
                            })}
                        </Text>
                    ) : null}
                </PackageSwitcherTitleWrapper>
                <CloseIcon
                    type="flat"
                    iconName="close"
                    iconSize="xs"
                    onClick={onClose}
                    data-automation="package-switcher-close-btn"
                />
            </PackageSwitcherHeader>
            {children}
            <PackageSwitcherFooter>
                <Button
                    type={isLoadingOrError ? "primary" : "flat"}
                    onClick={onCancelClick}
                    data-automation="package-switcher-cancel-btn"
                >
                    {translate("subscription.info.nt.cancel")}
                </Button>
                {isDataLoaded ? (
                    <Button
                        onClick={onSubmitButtonClick}
                        data-automation="package-switcher-submit-btn"
                    >
                        {translate("subscription.info.nt.change.plan")}
                    </Button>
                ) : null}
            </PackageSwitcherFooter>
        </PackageSwitcherWrapper>
    );
};
